import React from "react";
import * as PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import classnames from "classnames";
import styleConstants from "../../../../styleConstants";
import "./sector.scss";

const useStyles = makeStyles(theme => ({
  container: {
    cursor: "pointer",
    "&:hover": {
      "&>rect": {
        stroke: styleConstants.colors.gray6
      },
      "&>text": {
        fill: "#000000"
      }
    }
  },
  shape: {
    fill: "#ffffff",
    stroke: styleConstants.colors.gray3,
    strokeWidth: 1,
    strokeMiterlimit: 10,
    transition: "stroke 0.2s ease"
  },
  text: {
    //fontSize: "0.75rem",
    fontSize: "12px",
    fontWeight: styleConstants.fontWeights.book,
    fill: styleConstants.colors.gray5,
    textTransform: "uppercase",
    transition: "fill 0.2s ease"
  }
}));

const Junction = props => {
  const classes = useStyles();

  return (
    <g
      id={props.id}
      className={classnames(classes.container, "node")}
      onMouseEnter={props.updateCurrent}
      onMouseLeave={props.removeCurrent}
    >
      <rect
        className={classes.shape}
        width="100"
        height="40"
        x={props.x}
        y={props.y}
        rx="8"
      />
      <text
        className={classes.text}
        transform={`translate(${props.tx} ${props.ty})`}
        dangerouslySetInnerHTML={{ __html: props.content }}
      ></text>
    </g>
  );
};

Junction.propTypes = {
  id: PropTypes.string.isRequired,
  x: PropTypes.number,
  y: PropTypes.number,
  tx: PropTypes.number,
  ty: PropTypes.number,
  groups: PropTypes.arrayOf(PropTypes.string),
  content: PropTypes.string
};

export default Junction;
